// @flow
import React from "react";
import withStyles from "elevate-ui/withStyles";
import Button from "elevate-ui/Button";
import Typography from "elevate-ui/Typography";

type $Props = {
  hideMortgageCalc: boolean,
  classes: Object,
};

const MortgageCalculator = ({ classes }) => (
  <div className={classes.column}>
    <a
      href="/mortgage-calculator"
      className={classes.box}
      title="Mortgage Calculator"
      style={{
        background:
          "url(https://storage.googleapis.com/elevate-images/elevate-mortgage-calculator.jpg) center/cover no-repeat",
      }}
    >
      Calculate your monthly payments based on current mortgage rates.
    </a>
    <Typography className={classes.subheading} type="heading6">
      Calculate Payments
    </Typography>
    <Typography type="body" gutterBottom className={classes.tagline}>
      Calculate your monthly payments based on current mortgage rates.
    </Typography>
    <div className={classes.button}>
      <Button
        href="/mortgage-calculator"
        element="a"
        color="secondary"
        isOutlined
      >
        Mortgage Calculator
      </Button>
    </div>
  </div>
);

const renderMortgageCalculator = (
  hideMortgageCalc: boolean,
  classes: Object
) => {
  if (!hideMortgageCalc) {
    return <MortgageCalculator classes={classes} />;
  } else return;
};

const Box = ({ hideMortgageCalc, classes }: $Props) => {
  return (
    <div className={classes.root}>
      <Typography type="heading3" gutterTop gutterBottom>
        Featured Resources
      </Typography>
      <div className={classes.row}>
        <div className={classes.column}>
          <a
            href="/signup"
            className={classes.box}
            title="Sign up today"
            style={{
              background:
                "url(https://storage.googleapis.com/elevate-images/elevate-signup.jpg) center/cover no-repeat",
            }}
          >
            Sign up today for listing notifications
          </a>
          <Typography className={classes.subheading} type="heading6">
            Get Notified
          </Typography>
          <Typography type="body" gutterBottom className={classes.tagline}>
            It's never been easier to get new listing notifications.
          </Typography>
          <div className={classes.button}>
            <Button href="/signup" element="a" color="secondary" isOutlined>
              Sign Up Today
            </Button>
          </div>
        </div>
        <div className={classes.column}>
          <a
            href="/sell"
            className={classes.box}
            title="Sell your property"
            style={{
              background:
                "url(https://storage.googleapis.com/elevate-images/elevate-market-analysis.jpg) center/cover no-repeat",
            }}
          >
            Sell your home
          </a>
          <Typography className={classes.subheading} type="heading6">
            Market Analysis
          </Typography>
          <Typography type="body" gutterBottom className={classes.tagline}>
            Fill out a complimentary market analysis to learn the value of your
            home.
          </Typography>
          <div className={classes.button}>
            <Button href="/sell" element="a" color="secondary" isOutlined>
              Sell Your Property
            </Button>
          </div>
        </div>
        <div className={classes.column}>
          <a
            href="/blog"
            className={classes.box}
            title="Real estate blog"
            style={{
              background:
                "url(https://storage.googleapis.com/elevate-images/elevate-blog-resource.jpg) center/cover no-repeat",
            }}
          >
            Read the latest from the real estate blog
          </a>
          <Typography className={classes.subheading} type="heading6">
            Stay Informed
          </Typography>
          <Typography type="body" gutterBottom className={classes.tagline}>
            Read the latest real estate articles from my blog.
          </Typography>
          <div className={classes.button}>
            <Button href="/blog" element="a" color="secondary" isOutlined>
              Real Estate Blog
            </Button>
          </div>
        </div>
        {renderMortgageCalculator(hideMortgageCalc, classes)}
      </div>
    </div>
  );
};

const styles = (theme) => ({
  root: {
    width: "100%",
    maxWidth: "1170px",
    margin: "0 auto",
    padding: "48px 0",
    textAlign: "center",
  },
  row: {
    display: "flex",
    position: "relative",
    flexFlow: "row wrap",
    justifyContent: "space-around",
    alignItems: "stretch",
  },
  column: {
    flex: "0 1 100%",
    margin: "8px 8px 48px",
    padding: "0 40px 50px",
    position: "relative",
    [theme.breakpoints(542)]: {
      flex: "0 1 calc(50% - 16px)",
      margin: theme.spacing.unit * 0.5,
      padding: "0 0 50px",
    },
    [theme.breakpoints(900)]: {
      flex: "0 1 calc(25% - 16px)",
    },
  },
  box: {
    display: "block",
    position: "relative",
    height: "164px",
    marginBottom: theme.spacing.unit * 0.75,
    textIndent: "-10000px",
    borderRadius: theme.globalBorderRadius,
    opacity: "1",
    zIndex: 5,
    transition: "opacity 250ms ease",
    "&:after": {
      content: "''",
      display: "none",
      position: "absolute",
      width: "calc(100% + 10px)",
      height: "calc(100% + 10px)",
      top: "-5px",
      left: "-5px",
      border: theme.borders["default"],
      borderRadius: "2px",
      zIndex: 0,
    },
    "&:hover": {
      opacity: "0.75",
    },
  },
  tagline: {
    margin: "0 auto 8px",
    padding: "0 16px",
    fontSize: "16px",
    lineHeight: "26px",
  },
  button: {
    display: "flex",
    flexFlow: "row nowrap",
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
    bottom: "0",
    left: "0",
    right: "0",
  },
  subheading: {
    marginBottom: theme.spacing.unit * 0.25,
  },
});

export default withStyles(styles)(Box);
